import { FC } from 'react';
import { Event } from '../../types/common/Event.types';
import { DateBox, JustIn, LinkedWrapper, Place, Title, Wrapper } from './ui';
import ContentTypeLabel, { ContentTypeEnum } from '../ContentTypeLabel';
import { useTranslations } from '../../hooks/useTranslations';
import { getCalendarDaysToDate } from '../../utils/getCalendarDaysToDate';

type LastEvent = { passed: boolean; } & Pick<Event, 'typeOfEvent' | 'title' | 'eventDate' | 'place' | 'organizer' | 'rawEventDate' | 'href'>;

const LastEvent: FC<LastEvent> = ({ typeOfEvent, title, eventDate, place, organizer, passed, rawEventDate, href }) => {
  const daysToEvent = rawEventDate && !passed ? getCalendarDaysToDate(rawEventDate) : null;

  const { t, translate, translateByFullKey } = useTranslations();
  const titleText = translateByFullKey(title);
  const placeText = place || organizer;
  const isLinkedWorkshop = typeOfEvent === ContentTypeEnum.WORKSHOPS && href;

  const content = <>
    <div>
      <ContentTypeLabel contentType={typeOfEvent as ContentTypeEnum} reverse={!passed} />
      <Title passed={passed}>{titleText}</Title>
    </div>
    <div>
      <DateBox passed={passed}>
        {eventDate} {!passed && <JustIn>
        {daysToEvent === 0 ? t.HOME.NEXT_EVENT_TODAY : translate({
          value: t.HOME.NEXT_EVENT_IN,
          variables: [ daysToEvent.toString(), daysToEvent === 1 ? t.COMMON.DAY : t.COMMON.DAYS]
        })}
        </JustIn>}
      </DateBox>
      {placeText && <Place passed={passed}>{placeText}</Place>}
    </div>
  </>;

  if (isLinkedWorkshop) {
    return <LinkedWrapper href={href} passed={passed} title={titleText}>{content}</LinkedWrapper>
  }

  return <Wrapper passed={passed}>{content}</Wrapper>
}

export default LastEvent;
